import { EExploreTabs } from 'components/Explore/ExploreTabs/helpers/constants';
import useDiscoveryTab from 'helpers/useDiscoveryTab';

export const useCheckForCustomFeed = (): boolean => {
  const { discoveryTab } = useDiscoveryTab();

  return discoveryTab ? !Object.values<string>(EExploreTabs).includes(discoveryTab) : false;
};
